import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {AuthService} from '../services/auth.service';
import {catchError, map} from 'rxjs/operators';
import {of} from 'rxjs';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(
        private router: Router,
        private authService: AuthService
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.authService.me()
            .pipe(
                map(() => {
                    return true;
                }),
                catchError(() => {
                    // this.router.navigate(['/error']);
                    this.router.navigate(['/login']);
                    return of(false);
                })
            );
    }
}
